import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/use-language";
import { getNavLinks } from "@/constants/navigation";
import { LOGO } from "@/constants/assets";

// Footer Component
export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  const NAV_LINKS = getNavLinks(t);

  return (
    <footer
      className="relative py-12 bg-[#030014] border-t border-white/5"
      data-testid="footer"
    >
      <div className="max-w-[1800px] mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          className="flex flex-col lg:flex-row items-center justify-between gap-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Logo & Copyright */}
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <Link
              to="/"
              className="flex items-center"
              data-testid="footer-logo"
            >
              <img
                src={LOGO}
                alt="Phuong"
                className="w-10 h-10 object-contain"
              />
            </Link>
            <span className="text-white/30 text-sm">
              © {currentYear} Phuong. {t("footer.rights")}
            </span>
          </div>

          {/* Footer Links */}
          <nav
            className="flex flex-wrap justify-center gap-8"
            data-testid="footer-nav"
          >
            {NAV_LINKS.map((link) => {
              const isExternal =
                link.href.startsWith("http") || link.href.startsWith("mailto");
              if (isExternal) {
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    target={link.href.startsWith("http") ? "_blank" : undefined}
                    rel={
                      link.href.startsWith("http")
                        ? "noopener noreferrer"
                        : undefined
                    }
                    className="text-sm text-white/40 hover:text-[#FF2E63] transition-colors duration-300 tracking-wide"
                    data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {link.label}
                  </a>
                );
              }
              return (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-sm text-white/40 hover:text-[#FF2E63] transition-colors duration-300 tracking-wide"
                  data-testid={`footer-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        </motion.div>

        {/* Bottom */}
        <motion.div
          className="mt-8 pt-8 border-t border-white/5 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <p className="text-white/20 text-sm tracking-wide">
            {t("footer.madeWith")} <span className="text-[#FF2E63]">♥</span>{" "}
            {t("footer.by")}
          </p>
        </motion.div>
      </div>
    </footer>
  );
};
